import styled, { css } from 'styled-components';

import { device, screen } from '@/styles/helpers';

interface ScStaticModalProps {
  dark?: boolean;
  maxWidth?: number;
  fullHeight?: boolean;
  bgTransparent?: boolean;
  isHideTitleOnMobileS?: boolean;
  isNoPaddingMob?: boolean;
}

export const ScStaticModal = styled.div<ScStaticModalProps>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '640px')};
  border-radius: 16px;
  border-radius: 16px;
  background: ${({ theme, bgTransparent }) =>
    bgTransparent ? 'transparent' : theme.whiteColor};
  margin: 32px auto;
  padding: ${({ fullHeight }) => (fullHeight ? '0px' : '16px')};
  position: relative;

  font-size: 14px;
  line-height: 143%;
  color: ${({ theme }) => theme.blackLightColor};

  @media (${device.mobileS}) {
    display: flex;
    flex-direction: column;
    margin: 0 16px;
    background: none;
    width: 100%;
    max-width: 100%;
    color: ${({ theme }) => theme.grayMegaLightColor};
    margin: 0;
    height: 100dvh;
    overflow-y: auto;
    border-radius: 0;
    ${({ isNoPaddingMob }) => isNoPaddingMob && 'padding: 0;'}
  }

  & > h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .date {
    color: ${({ theme }) => theme.blackColor};
    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  .date {
    margin-bottom: 24px;
  }

  h1 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    position: relative;
    margin: 0 40px 24px 0;
    height: 40px;
    display: flex;
    align-items: center;

    i {
      font-size: 40px;
      margin-right: 8px;
    }
    @media (${device.mobileS}) {
      margin-bottom: 24px;

      i {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  h2 {
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.01em;
    margin-bottom: 16px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.blackColor};
    text-align: left;

    &:not(:first-child) {
      margin-top: 24px;
    }

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor} !important;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid ${({ theme }) => theme.blackLightColor};
    padding: 8px;
    text-align: left;
  }

  .horizontal-scroll {
    overflow-x: auto;
  }

  td,
  th {
    font-weight: 400;
  }

  ol,
  ul {
    list-style-type: none;
    margin-bottom: 16px;
    li:not(:last-child) {
      margin-bottom: 8px;
    }
  }
  ol {
    counter-reset: modal-list-counter;
    position: relative;
    padding-left: 16px;

    & li {
      counter-increment: modal-list-counter;

      &::before {
        content: counter(modal-list-counter) ".";
        position: absolute;
        color: currentColor;
        font-size: inherit;
        left: 0;
      }
    }
  }
  h4 {
    margin-bottom: 8px;
    font-size: larger;
  }

  ${({ isHideTitleOnMobileS }) =>
    isHideTitleOnMobileS &&
    css`
      @media (${device.mobileS}) {
        & > h1,
        & > button {
          display: none;
        }
      }
    `}
  ${({ dark, theme }) =>
    dark &&
    css`
      background: ${theme.blackColor};
      color: ${theme.grayMegaLightColor};

      @media (${screen.md}) {
        background: ${theme.grayDarkColor};
      }

      & > h1,
      & h2,
      & h3,
      & h4,
      & h5,
      & h6,
      & .date {
        color: ${theme.whiteColor};
      }
    `}

`;
